module.exports = __webpack_public_path__ + "static/media/retirement-object-4-1-2.ca691ce8.svg";